import { i18n } from 'src/boot/i18n'

export const HOURS_PER_DAY = 24
const DAYS_PER_WEEK = 7
export const HOURS_PER_WEEK = HOURS_PER_DAY * DAYS_PER_WEEK

const MINUTES_PER_HOUR = 60
const MINUTES_PER_DAY = HOURS_PER_DAY * MINUTES_PER_HOUR
const MINUTES_PER_WEEK = HOURS_PER_WEEK * MINUTES_PER_HOUR

function decompose(totalHours: number) {
  const totalMinutes = Math.round(totalHours * MINUTES_PER_HOUR)
  return {
    weeks: Math.floor(totalMinutes / MINUTES_PER_WEEK),
    days: Math.floor((totalMinutes % MINUTES_PER_WEEK) / MINUTES_PER_DAY),
    hours: Math.floor((totalMinutes % MINUTES_PER_DAY) / MINUTES_PER_HOUR),
    minutes: totalMinutes % MINUTES_PER_HOUR,
  }
}

/**
 * Human-readable duration from a total number of hours (may be fractional): drops
 * zero components and joins as "1 week, 2 days and 1 hour", adding a "N minutes"
 * segment for a sub-hour remainder (6.5h → "6 hours and 30 minutes"). Whole-hour
 * callers get no minutes segment. Returns '' for 0.
 */
export function formatDurationHours(totalHours: number): string {
  const { weeks, days, hours, minutes } = decompose(totalHours)

  const segments: string[] = []
  if (weeks) {
    segments.push(`${weeks} ${i18n.global.t('period_unit.weeks', weeks)}`)
  }
  if (days) {
    segments.push(`${days} ${i18n.global.t('period_unit.days', days)}`)
  }
  if (hours) {
    segments.push(`${hours} ${i18n.global.t('period_unit.hours', hours)}`)
  }
  if (minutes) {
    segments.push(`${minutes} ${i18n.global.t('period_unit.minutes', minutes)}`)
  }

  if (segments.length <= 1) {
    return segments.join('')
  }
  // The "A, B and C" join is locale-specific (the conjunction is not English-only),
  // so the pattern lives in `period_unit.list_last` rather than being hardcoded.
  return i18n.global.t('period_unit.list_last', {
    items: segments.slice(0, -1).join(', '),
    last: segments[segments.length - 1],
  })
}
